import React from 'react';
import { Box, VStack } from '@chakra-ui/react';
import ShimmerThinking from './ShimmerThinking';

/**
 * Message list component
 * Renders a scrollable list of messages with auto-scroll
 * 
 * @param {Object} props
 * @param {Array} props.messages - Array of message objects
 * @param {React.ReactNode} props.children - Message bubble components
 * @param {boolean} props.isAgentThinking - Whether agent is thinking
 * @param {React.Ref} props.messagesEndRef - Ref for auto-scroll target
 */
const MessageList = ({ messages, children, isAgentThinking, messagesEndRef }) => {
  return (
    <Box 
      flex={1} 
      overflowY="auto" 
      overflowX="hidden"
      p={4}
      minH={0}
      maxH="100%"
      position="relative"
      css={{
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
          background: 'rgba(255,255,255,0.10)',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: 'rgba(255,255,255,0.18)',
        },
      }}
    >
      <VStack spacing={0} align="stretch">
        {children}
        {isAgentThinking && <ShimmerThinking />}
        <div ref={messagesEndRef} />
      </VStack>
    </Box>
  );
};

export default MessageList;

